<template>
    <DCard padding>
        <Form
            :errors="errors"
            :configurations="configurations"
            :brands="brands"
            :placeholders="placeholders"
            :all-languages="allLanguages"
            :edit-page="false"
            @DunningPdfSettingFormSubmit="save"
        />
    </DCard>
</template>

<script>

import Form from '~@/Components/Settings/DunningPdfSettings/Form.vue'

export default {
    name: 'CreateDunningPdfSettingsConfigurations',
    components: { Form },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        configurations: {
            type: Array,
            default: () => { return [] }
        },
        placeholders: {
            type: Array,
            default: () => { return [] }
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        allLanguages: {
            type: Array,
            default: () => { return [] }
        }
    },
    methods: {
        save (form) {
            form.post(this.$route('settings.dunning-pdf-settings.store'))
        }
    }
}
</script>
